import Routes from '@/components/routes/Routes'
import mainTheme from '@/components/themes/mainTheme'
import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import './css/embla.css'

const App: React.FC = () => {
  const loader = document.getElementById('loader')
  loader?.classList.add('loaded')

  setTimeout(() => {
    loader?.remove()
  }, 1000)

  return (
    <>
      <React.StrictMode>
        <BrowserRouter>
          <React.Suspense fallback={<></>}>
            <ThemeProvider theme={mainTheme}>
              <Routes />
            </ThemeProvider>
          </React.Suspense>
        </BrowserRouter>
      </React.StrictMode>
    </>
  )
}

export default App
